import PdfPage from "../../components/PdfPage";

export default function AccountOpenDetails() {
  return (
    <main>
      <PdfPage
        h1={"DOCUMENTS FOR ACCOUNT OPENING"}
        h2={"Account Open Detail"}
        img={
          "/img/PSX-logo.jpg"
        }
        pdf1={
          "https://api.orbitsecurities.com.pk/media/cms/documents/normal-account.pdf"
        }
        pdf1Text={" For Normal Account"}
        pdf2={
          "https://api.orbitsecurities.com.pk/media/cms/documents/sahulat-account-form.pdf"
        }
        pdf2Text={"For Sahulat Account"}
      />
    </main>
  );
}
